// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userProfile_container__Owk7f {
  border: solid 2px #055437;
  width: 100%;
  height: 150px;
  margin: 0.5em;
  display: flex;
  border-radius: 25px;
  box-shadow: -2px 4px #979797;
  color: #055437;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-all;
  max-height: 150px;
}

.userProfile_contentOne__EkEO- {
  display: flex;
  flex-direction: column;
  width: 50%;
  text-align: start;
  margin: auto;
  padding-left: 5em;
}

.userProfile_contentTwo__2yNT0 {
  display: flex;
  flex-direction: column;
  width: 50%;
  text-align: start;
  margin-top: 18px;
  padding-left: 5em;
}

.userProfile_main__i9nw\\+ {
  margin-top: 50px;
  height: 300px;
  border: solid 1px #979797;
  background-color: #2d3436;
  border-radius: 25px;
  box-shadow: -2px 4px #979797;
  color: white;
  display: flex;
}

.userProfile_userContent__0Gyp6 {
  text-align: start;
  display: flex;
  flex-direction: column;
  width: 50%;
}

.userProfile_userContentTwo__BrdEU {
  display: flex;
  flex-direction: column;
  width: 50%;
  text-align: start;
  margin-top: 72px;
}

.userProfile_imgContainer__FMFgn {
  display: flex;
  padding: 1.5em;
}
.userProfile_imgContainer__FMFgn img {
  border-radius: 50%;
  border: 3px solid white;
}

.userProfile_addContainer__nnIAf {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  text-align: center;
  color: #055437;
  width: 100%;
  padding-right: 0.5em;
}

.userProfile_content__qqZoa {
  display: flex;
  cursor: pointer;
}

.userProfile_title__sGnnO {
  padding-top: 0.1em;
  padding-left: 0.5em;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  width: 100%;
  font-size: 1.2em;
  font-family: 'IBM Plex Sans', sans-serif;
}

.userProfile_userContentTwo__BrdEU input {
  border-radius: 25px;
  color: black;
  padding-left: 0.5em;
}

.userProfile_buttonDiv__WIGY1 {
  display: flex;
  justify-content: start;
  margin-left: 5.2em;
}

.userProfile_buttonDiv__WIGY1 button {
  padding: 0.5em;
  margin: 0.5em;
  color: white;
  border-radius: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/userProfile.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".container {\n  border: solid 2px #055437;\n  width: 100%;\n  height: 150px;\n  margin: 0.5em;\n  display: flex;\n  border-radius: 25px;\n  box-shadow: -2px 4px #979797;\n  color: #055437;\n  overflow-y: auto;\n  overflow-x: hidden;\n  word-break: break-all;\n  max-height: 150px;\n}\n\n.contentOne {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  text-align: start;\n  margin: auto;\n  padding-left: 5em;\n}\n\n.contentTwo {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  text-align: start;\n  margin-top: 18px;\n  padding-left: 5em;\n}\n\n.main {\n  margin-top: 50px;\n  height: 300px;\n  border: solid 1px #979797;\n  background-color: #2d3436;\n  border-radius: 25px;\n  box-shadow: -2px 4px #979797;\n  color: white;\n  display: flex;\n}\n\n.userContent {\n  text-align: start;\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n\n.userContentTwo {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  text-align: start;\n  margin-top: 72px;\n}\n\n.imgContainer {\n  display: flex;\n  padding: 1.5em;\n}\n.imgContainer img {\n  border-radius: 50%;\n  border: 3px solid white;\n}\n\n.addContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 20px;\n  text-align: center;\n  color: #055437;\n  width: 100%;\n  padding-right: 0.5em;\n}\n\n.content {\n  display: flex;\n  cursor: pointer;\n}\n\n.title {\n  padding-top: 0.1em;\n  padding-left: 0.5em;\n  text-decoration: none;\n  font-weight: 600;\n  display: flex;\n  width: 100%;\n  font-size: 1.2em;\n  font-family: 'IBM Plex Sans', sans-serif;\n}\n\n.userContentTwo input {\n  border-radius: 25px;\n  color: black;\n  padding-left: 0.5em;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: start;\n  margin-left: 5.2em;\n}\n\n.buttonDiv button {\n  padding: 0.5em;\n  margin: 0.5em;\n  color: white;\n  border-radius: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `userProfile_container__Owk7f`,
	"contentOne": `userProfile_contentOne__EkEO-`,
	"contentTwo": `userProfile_contentTwo__2yNT0`,
	"main": `userProfile_main__i9nw+`,
	"userContent": `userProfile_userContent__0Gyp6`,
	"userContentTwo": `userProfile_userContentTwo__BrdEU`,
	"imgContainer": `userProfile_imgContainer__FMFgn`,
	"addContainer": `userProfile_addContainer__nnIAf`,
	"content": `userProfile_content__qqZoa`,
	"title": `userProfile_title__sGnnO`,
	"buttonDiv": `userProfile_buttonDiv__WIGY1`
};
export default ___CSS_LOADER_EXPORT___;
